<template>
    <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.239 6.489V7.33275C15.129 7.569 15.75 8.5275 15.75 10.8833V12.1388C15.75 14.9062 14.9062 15.75 12.1388 15.75H5.86125C3.09375 15.75 2.25 14.9062 2.25 12.1388V10.8833C2.25 8.5275 2.871 7.569 4.761 7.33275V6.489C4.761 4.6665 5.19975 2.25 9 2.25C12.8003 2.25 13.239 4.6665 13.239 6.489ZM6.9615 11.511C6.9615 12.6315 7.87275 13.5495 9 13.5495C10.1273 13.5495 11.0385 12.6383 11.0385 11.511C11.0385 10.3905 10.1205 9.4725 9 9.4725C7.8795 9.4725 6.9615 10.3837 6.9615 11.511ZM5.706 7.272H5.86125V7.27875H12.294V6.489C12.294 4.51125 11.7338 3.195 9 3.195C6.26625 3.195 5.706 4.51125 5.706 6.489V7.272Z"
            fill="#FF9E48"
        />
    </svg>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>
